import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Landmark, ArrowRight } from "lucide-react";
import { money } from "@/components/obboard/BoardFilters";
import { monthName } from "@/components/obboard/Forecast";

export const ForecastCard = ({ scope }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/obligations-board/forecast", { params: { scope } }).then((r) => setD(r.data)).catch(() => setD(false)); }, [scope]);
  if (d === false) return null;
  return (
    <section data-testid="forecast-card" className="mt-8 bg-white border border-blue-200 rounded-md">
      <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
        <div className="flex items-center gap-2"><Landmark className="w-4 h-4 text-blue-700" /><div className="text-sm font-semibold tracking-tight">Funds needed · next 3 months</div></div>
        <Link to="/obligations/board?view=forecast" data-testid="forecast-card-open" className="text-xs text-blue-700 inline-flex items-center gap-1 hover:underline">Full forecast <ArrowRight className="w-3.5 h-3.5" /></Link>
      </div>
      {!d ? <div className="p-5 text-sm text-slate-500">Loading…</div> : (
        <div className="p-5 grid md:grid-cols-[repeat(3,1fr)_1.4fr] gap-4">
          {d.months.map((m, i) => (
            <div key={m} data-testid={`forecast-card-month-${i}`}>
              <div className="text-[11px] uppercase tracking-wider text-slate-500">{monthName(m)}{i === 0 ? " · incl. overdue" : ""}</div>
              <div className="mono text-xl font-semibold text-blue-800 mt-1">{money(d.totals[i].amount, true)}</div>
              <div className="text-[11px] text-slate-500">{d.totals[i].count} payment(s)</div>
            </div>
          ))}
          <div className="border-l border-slate-100 pl-4">
            <div className="text-[11px] uppercase tracking-wider text-slate-500 mb-1">Largest needs</div>
            {d.rows.slice(0, 4).map((r) => (
              <div key={r.entity} className="flex justify-between text-sm py-0.5"><span className="truncate text-slate-700">{r.entity === "—" ? "No entity" : r.entity}</span><span className="mono text-slate-900">{money(r.total, true)}</span></div>
            ))}
            {d.rows.length === 0 && <div className="text-sm text-slate-500">Nothing due.</div>}
          </div>
        </div>
      )}
    </section>
  );
};
